import { createAction, handleActions } from 'redux-actions'
import { Pocket } from 'types/common'
import { FetchStates } from 'constants/common'

export type PocketsState = {
  data: Pocket[]
  fetchState: FetchStates | null
}

const initialState: PocketsState = {
  data: [],
  fetchState: FetchStates.PENDING,
}

export const setPocketsAction = createAction<Pocket[]>('/pockets/SET_POCKETS')
export const setPocketsFetchingAction = createAction('/pockets/SET_FETCHING')

export const pocketsReducer = handleActions<PocketsState, any>(
  {
    [setPocketsAction as any]: (state, action) => ({
      ...state,
      data: action.payload,
      fetchState: FetchStates.SUCCESS,
    }),
    [setPocketsFetchingAction as any]: (state: any) => ({
      ...state,
      fetchState: FetchStates.PENDING,
    }),
  },
  initialState,
)
